export class Region {
    code: string;
    name: string;
    nameLat: string;
  }